import { DEFAULT_FONT_SIZE } from '../constants/common';

import { FONT_SIZE } from '../components/AppTable/constants';

export const theme = {
  token: {
    borderRadius: 2,
    colorBgMask: 'rgba(0, 0, 0, 0.1)',
    colorPrimary: '#51ae32',
    colorInfo: '#51ae32',
    fontFamily: '"Nunito Sans", sans-serif',
    fontSize: DEFAULT_FONT_SIZE
  },
  components: {
    Button: {
      primaryShadow: 'none',
      defaultShadow: 'none'
    },
    Card: {
      bodyPadding: '0.5rem',
      headerFontSize: '1rem',
      headerPadding: '0.5rem'
    },
    Dropdown: {
      zIndexPopup: 10
    },
    Form: {
      itemMarginBottom: 10,
      verticalLabelPadding: '0 0 5px 0',
      labelRequiredMarkColor: '#e73a1e'
    },
    Input: {
      activeShadow: 'none'
    },
    List: {
      itemPaddingSM: '6px 0'
    },
    Select: {
      activeOutlineColor: 'transparent'
    },
    Table: {
      bodySortBg: 'rgb(229, 237, 223)',
      headerBg: '#f6f6f6',
      headerColor: '#9d9d9d',
      cellPaddingInlineSM: 5,
      cellPaddingBlockSM: 6,
      cellPaddingBlockMD: 8,
      cellPaddingBlock: 10,
      cellFontSize: FONT_SIZE.LG,
      cellFontSizeMD: FONT_SIZE.MD,
      cellFontSizeSM: FONT_SIZE.SM,
      headerBorderRadius: 2
    },
    Typography: {
      titleMarginBottom: 0,
      titleMarginTop: 0
    }
  }
};
